import React from 'react'
import style from './index.module.less'
import { CheckCircleOutlined } from '@ant-design/icons'
import cls from 'classnames'
export default props => {
  const { item, type } = props
  const isShow = item.pro === '2' && type === 'standard'
  const isPro = item.pro === '2' && type === 'pro'
  return (
    <div
      className={cls(style.standard, { [style.pro]: isPro })}
      style={{
        visibility: isShow ? 'hidden' : 'visible'
      }}
    >
      <CheckCircleOutlined />
      <span className="version-name">{item.name}</span>
    </div>
  )
}
